<nav class="navbar navbar-expand-lg navbar-dark bg-secondary"
  *ngIf="actionLinksPanelService.actionLinks && actionLinksPanelService.actionLinks.length>0">
  <ul class="action-link-list">
    <li class="action-link-list-item" *ngFor="let actionLink of actionLinksPanelService.actionLinks; let i = index;">
      <a *ngIf="onLinkClicked!=null && actionLink.href=='' && !shouldUseReallyClick(i)" (click)="onLinkClicked(i)"><i
          class="fa fa-{{actionLink.fontAwesomeIcon}}"></i> {{ actionLink.text }}</a>
      <a *ngIf="actionLink.href!='' && !shouldUseReallyClick(i)" routerLink="{{actionLink.href}}"><i
          class="fa fa-{{actionLink.fontAwesomeIcon}}"></i> {{ actionLink.text }}</a>
      <a *ngIf="shouldUseReallyClick(i)" [reallyClick]="actionLink.reallyClickMessage"
        [reallyClickAction]="actionLink.reallyClickAction" [reallyClickCaller]="actionLink.reallyClickCaller"
        [reallyClickArguments]="actionLink.reallyClickArgs" [reallyClickButtons]="actionLink.reallyClickButtons"><i
          class="fa fa-{{actionLink.fontAwesomeIcon}}"></i>{{ actionLink.text }}</a>
    </li>
  </ul>
</nav>